import { Bonuses, Booking, BookingDetails, BookingList, CheckIn, Clients, SignIn, Spending, Statistics, Reports } from "pages";
import { createBrowserRouter, Navigate } from "react-router-dom";

import ErrorBoundary from "../components/ErrorBoundary/ErrorBoundary.tsx";
import { BookingProvider } from "../utils/context/Booking/BookingContext.tsx";

import { ProtectedRoute } from "./ProtectedRoute.tsx";
import { Routes } from "./routes";

const router = createBrowserRouter([
  {
    path: Routes.Root,
    element: (
      <ErrorBoundary>
        <ProtectedRoute>
          <BookingList />
        </ProtectedRoute>
      </ErrorBoundary>
    ),
  },
  {
    path: Routes.BookingById,
    element: (
      <ErrorBoundary>
        <ProtectedRoute>
          <BookingProvider>
            <Booking />
          </BookingProvider>
        </ProtectedRoute>
      </ErrorBoundary>
    ),
  },
  {
    path: Routes.Clients,
    element: (
      <ErrorBoundary>
        <ProtectedRoute>
          <BookingProvider>
            <Clients />
          </BookingProvider>
        </ProtectedRoute>
      </ErrorBoundary>
    ),
  },
  {
    path: Routes.SignIn,
    element: (
      <ErrorBoundary>
        <SignIn />
      </ErrorBoundary>
    ),
  },
  {
    path: Routes.BookingDetails,
    element: (
      <ErrorBoundary>
        <ProtectedRoute>
          <BookingDetails />
        </ProtectedRoute>
      </ErrorBoundary>
    ),
  },
  {
    path: Routes.CheckIn,
    element: (
      <ErrorBoundary>
        <ProtectedRoute>
          <CheckIn />
        </ProtectedRoute>
      </ErrorBoundary>
    ),
  },
  {
    path: Routes.Spending,
    element: (
      <ErrorBoundary>
        <ProtectedRoute>
          <Spending />
        </ProtectedRoute>
      </ErrorBoundary>
    ),
  },
  {
    path: Routes.Statistics,
    element: (
      <ErrorBoundary>
        <ProtectedRoute>
          <Statistics />
        </ProtectedRoute>
      </ErrorBoundary>
    ),
  },
  {
    path: Routes.Reports,
    element: (
      <ErrorBoundary>
        <ProtectedRoute>
          <Reports />
        </ProtectedRoute>
      </ErrorBoundary>
    ),
  },
  {
    path: Routes.Bonuses,
    element: (
      <ErrorBoundary>
        <ProtectedRoute>
          <Bonuses />
        </ProtectedRoute>
      </ErrorBoundary>
    ),
  },
  {
    path: "*",
    element: <Navigate to={Routes.Root} />,
  },
]);

export default router;
